@use '@design/design-tokens/typography/typography' as *;

.container {
  overflow: auto;
}

.title {
  @include typography-v2-title-md;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-soft);
}

.styledTable {
  padding: 0;

  > td,
  th {
    padding: 12px;
  }
}

.styledTableHeader {
  white-space: normal;
  background-color: var(--background-soft);
}

.styledTableCell {
  background-color: var(--background-soft);
}

.styledRowHeaderLabel {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
